import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import PageHeadingNew from "../../common-components/custom-comps/PageHeadingNew";
import CmnFilters from "../../lead-management/common/CmnFilters";
import { FORMATTED_TODAY_DATE_YYYYMMDD } from "../../common-data/Converts";
import {
  fetchRenewalCheckinData,
  fetchRenewalCheckinStatData,
} from "../../../redux/live-reducers/liveSlice";
import RenewalCheckinLogs from "./RenewalCheckinLogs";
import RenewalCheckinsStat from "./RenewalCheckinsStat";
import RenewalWebhook from "./RenewalWebhook";

const LiveRenewalStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    leadAddDateFrom: FORMATTED_TODAY_DATE_YYYYMMDD,
    leadAddDateTo: FORMATTED_TODAY_DATE_YYYYMMDD,
    selectedPlanDuration: "",
    selExpiringInDays: "",
    selAddedby: "",
    isActive: "",
    searchString: "",
    showFiltersDropdown: false,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    days_remaining: allFilters.selExpiringInDays?.value || "",
    resolved_by: allFilters.selAddedby?.value || "",
    duration: allFilters.selectedPlanDuration?.value || "",
    is_resolved: allFilters.isActive?.value || "",
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const [statsData, setStatsData] = useState({
    total: 0,
    monthly: 0,
    quaterly: 0,
    half_yearly: 0,
    yearly: 0,
  });
  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getRenewalStats(filters) {
    const { page, limit, ...rest } = filters;

    dispatch(
      fetchRenewalCheckinStatData({
        filters: { ...rest },
        token: userInfoData?.token,
      })
    );
  }

  function getRenewals(filters) {
    dispatch(
      fetchRenewalCheckinData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getRenewalStats(filters);
  }, [
    filters.gym_id,
    filters.days_remaining,
    filters.resolved_by,
    filters.duration,
    filters.date_from,
    filters.date_to,
    filters.is_resolved,
  ]);

  useEffect(() => {
    getRenewals(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      days_remaining: allFilters.selExpiringInDays?.value || "",
      duration: allFilters.selectedPlanDuration?.value || "",
      resolved_by: allFilters.selAddedby?.value || "",
      is_resolved: allFilters.isActive?.value || "",
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selExpiringInDays,
    allFilters.selectedPlanDuration,
    allFilters.selAddedby,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.isActive,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin && !isClusterManager
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  return (
    <Container className="bg-cloud-k px-50px" fluid>
      <Row>
        <Col>
          <RenewalWebhook
            userInfoData={userInfoData}
            setStatsData={setStatsData}
            setAllDatas={setAllDatas}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <PageHeadingNew
            heading="Live Renewal Reminder"
            subheading="Real-time Member Checkins Logs Monitoring and Management"
            onReload={() => {
              getRenewalStats(filters);
              getRenewals(filters);
            }}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from="renewal-reminder"
            userInfoData={userInfoData}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickReset={onResetFilters}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
          />
        </Col>
      </Row>

      {allFilters.showFiltersDropdown && (
        <Row>
          <Col>
            <RenewalCheckinsStat
              statsData={statsData}
              setStatsData={setStatsData}
            />
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          <RenewalCheckinLogs
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            allDatas={allDatas}
            setAllDatas={setAllDatas}
            userInfoData={userInfoData}
            callFunction={() => {
              getRenewalStats(filters);
              getRenewals(filters);
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default LiveRenewalStructure;
